import axios from "axios";
import { ServerError } from "../define/ServerError";
import { CqlParameter } from "./CqlParameter";

/**
 * WFS 地物情報（API）取得クラス
 */
export class WMSGetFeatureManager {
  /**
   * Authorizationヘッダに与えるIDトークンを設定する
   * @param idToken Authorizationヘッダに与える値
   */
  static setIdToken(_idToken: string) {
    return;
  }

  /**
   * WMS GeoJSON取得メソッド
   * @param url API通信URL
   * @param bBox bBOX
   * @param cqlParameter CQLパラメータ
   * @param mouseX マウスX座標
   * @param mouseY マウスY座標
   * @param height 地図表示高さ
   * @param width 地図表示幅
   * @param buffer 地物クリックバッファ
   */
  async getInfo(
    url: string,
    bBox: string,
    cqlParameter: CqlParameter[],
    mouseX?: number,
    mouseY?: number,
    height?: number,
    width?: number,
    buffer?: number
  ): Promise<any> {
    const layers: string[] = [];
    const cqlParams: string[] = [];
    cqlParameter.forEach((elements) => {
      layers.push(elements._layerName);
      if (elements._cqlParameter) cqlParams.push(elements._cqlParameter);
    });
    // 後からプロパティを追加できるよう宣言
    interface Params {
      [key: string]: any;
    }
    const params: Params = {
      service: "WMS",
      version: "1.3.0",
      request: "GetFeatureInfo",
      layers: layers.join(","),
      styles: "",
      srs: "EPSG:3857",
      bbox: bBox,
      width: width ?? "",
      height: height ?? "",
      query_layers: layers.join(","),
      info_format: "application/json",
      x: mouseX ?? "",
      y: mouseY ?? "",
      exceptions: "application/json",
      FEATURE_COUNT: "100",
      buffer: buffer,
    };
    // 市区町村ポリゴン等でcql_parameter指定しない場合があるため、後から追加
    if (cqlParams.length) params.cql_filter = cqlParams.join(";");
    const requestConfig = {
      method: "GET",
      url,
      params,
      headers: {
        custom: "viewer",
      },
    };
    const response = await axios(requestConfig).catch((error) => {
      // 接続エラー処理
      throw new ServerError(
        error.config.url,
        error.response?.status ?? "0",
        error.response?.message
      );
    });
    // リクエスト成功時エラー処理
    if (response.data.exceptions) {
      const codes = response.data.exceptions.map((e: any) => e.code);
      const texts = response.data.exceptions.map((e: any) => e.text);
      const serverError = new ServerError(response.config.url, codes, texts);
      console.error(serverError);
      throw serverError;
    }
    return response.data;
  }
}
